import React, { ComponentPropsWithoutRef } from 'react';
import { Text, TextAppearance, TextProps } from '../../../../components/Text';
import { identifyComponent } from '../../../../util';

type AllowedTags = 'span' | 'div';
type TextStyles<A extends TextAppearance> = {
  appearance?: A;
} & Pick<TextProps<A, AllowedTags>, 'color' | 'noWrap' | 'align' | 'tag' | 'testId'> &
  ComponentPropsWithoutRef<AllowedTags>;

interface TitleSubtitleCellContentProps<A extends TextAppearance> {
  title: string;
  titleStyles?: TextStyles<A>;
  subtitle?: string;
  subtitleStyles?: TextStyles<A>;
}

export const TitleSubtitleCellContent = <A extends TextAppearance>({
  title,
  titleStyles = {},
  subtitle,
  subtitleStyles = {},
}: TitleSubtitleCellContentProps<A>) => (
  <>
    <Text
      appearance="bodyMedium"
      tag="span"
      {...titleStyles}
      {...identifyComponent('table-subtitle-cell-content')}
    >
      {title}
    </Text>
    {subtitle && (
      <>
        <br />
        <Text appearance="bodyMedium" tag="span" {...subtitleStyles}>
          {subtitle}
        </Text>
      </>
    )}
  </>
);
